export default __webpack_public_path__ + "static/media/36I-102763_-15872_0.50d53d66.jpg";